export default "__VITE_ASSET__Dta3azt4__"